//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import layout from '~/mixins/layout'

export default {
  mixins: [layout],
  inheritAttrs: false,
  props: {
    type: {
      type: String,
      default: 'PageGridIcon',
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: Object,
      default: () => {},
    },
    iconContent: {
      type: Array,
      default: () => [],
    },
    isLandingpage: {
      type: Boolean,
      default: false,
    },
    anchorId: {
      type: Object,
      default: () => {},
    },
    pageId: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      innerWidth: window.innerWidth,
      navScroll: {
        scroll: null,
        width: null,
        bounceWidth: 18,
      },
    }
  },
  computed: {},
  mounted() {},

  methods: {},
}
